module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/hospitals/noimage_s800x424-e7bf443da9d8b0fe725db65dc1979af9.png";